import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="prose prose-lg max-w-none" dir="rtl">
        <h1 className="text-3xl font-bold mb-8">
          תקנון השימוש באתר "מזרח ללא גבולות" ובקהילות במדיה החברתית
        </h1>
        <p className="text-gray-600 mb-8">עדכון אחרון: מרץ 2025</p>

        <p>
          תקנון זה מסדיר את השימוש באתר "מזרח ללא גבולות" (להלן: "האתר")
          ובקהילות הקשורות אליו במדיה החברתית (להלן: "הקהילות"). השימוש באתר
          ובקהילות מהווה הסכמה מלאה לכל התנאים המפורטים להלן.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">1. הגדרות כלליות</h2>
        <div className="space-y-2">
          <p>
            1.1 האתר - אתר האינטרנט "מזרח ללא גבולות" המספק מידע, מדריכים,
            מסלולי טיול, המלצות ושירותים בתחום התיירות במזרח הרחוק.
          </p>
          <p>
            1.2 קהילות - קבוצות מדיה חברתית הקשורות לאתר (פייסבוק, וואטסאפ
            וכו'), בהן מתקיים שיח חופשי בין מטיילים.
          </p>
          <p>
            1.3 משתמש - כל אדם אשר עושה שימוש באתר או בקהילות, לרבות צפייה
            בתכנים, פרסום פוסטים, תגובות או שליחת הודעות פרטיות.
          </p>
          <p>
            1.4 מנהלי האתר - בעל האתר והגורמים המוסמכים מטעמו, אשר אחראים על
            תפעול האתר והקהילות.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">
          2. שימוש באתר ובקהילות - תנאים והסכמות
        </h2>
        <div className="space-y-4">
          <p>
            2.1 השימוש באתר ובקהילות הוא על אחריותך בלבד - הנהלת האתר אינה
            אחראית לכל נזק, ישיר או עקיף, שעלול להיגרם עקב הסתמכות על מידע, תוכן
            או שירותים המפורסמים באתר או בקהילות.
          </p>

          <div>
            <p>2.2 פרסום מידע ותוכן על ידי המשתמשים -</p>
            <ul className="list-disc mr-8 mt-2">
              <li>
                חל איסור מוחלט לפרסם מידע שקרי, פוגעני, מסית, פורנוגרפי, מאיים,
                מזיק או מפר זכויות יוצרים.
              </li>
              <li>
                הנהלת האתר רשאית להסיר כל תוכן שאינו עומד בהנחיות אלו ולחסום
                משתמשים ללא הודעה מוקדמת.
              </li>
            </ul>
          </div>

          <div>
            <p>2.3 שימוש מסחרי והמלצות -</p>
            <ul className="list-disc mr-8 mt-2">
              <li>
                אין לפרסם שירותים מסחריים, פרסומות או הצעות שיווקיות ללא אישור
                מראש מהנהלת האתר.
              </li>
              <li>
                המשתמשים רשאים לשתף חוויות והמלצות באופן חופשי, כל עוד הן
                מבוססות על חוויות אישיות ואינן מקדמות אינטרסים מסחריים גלויים או
                נסתרים.
              </li>
            </ul>
          </div>

          <div>
            <p>2.4 שמירה על שיח מכבד בקהילה -</p>
            <ul className="list-disc mr-8 mt-2">
              <li>
                המשתמשים מתחייבים להימנע מהתבטאויות פוגעניות, גזעניות, לשון הרע
                או השמצות.
              </li>
              <li>מנהלי הקהילה רשאים להסיר משתמשים המפרים את כללי ההתנהגות.</li>
            </ul>
          </div>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">
          3. אחריות המשתמשים על תכנים שהועלו
        </h2>
        <div className="space-y-2">
          <p>
            3.1 כל משתמש המעלה תוכן לאתר או לקהילות מצהיר כי הוא הבעלים החוקי של
            התוכן, או שיש לו זכויות להשתמש בו.
          </p>
          <p>
            3.2 הנהלת האתר לא תישא באחריות לכל טענה של צד שלישי בגין הפרת זכויות
            יוצרים.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. אחריות האתר</h2>
        <div className="space-y-4">
          <div>
            <p>4.1 דיוק המידע וההמלצות -</p>
            <ul className="list-disc mr-8 mt-2">
              <li>
                המידע באתר מבוסס על חוויות, ידע והמלצות של מטיילים, אך אין לראות
                בו מידע מחייב.
              </li>
              <li>
                הנהלת האתר אינה אחראית לכל טעות, חוסר דיוק או שינוי במידע.
              </li>
            </ul>
          </div>

          <p>
            4.2 קישורים לאתרים חיצוניים - האתר עשוי להכיל קישורים לאתרים
            חיצוניים, אך אינו אחראי לתוכנם, איכותם או אמינותם.
          </p>
          <p>
            4.3 תקלות טכניות ונגישות - הנהלת האתר עושה מאמצים לשמור על תקינותו,
            אך אינה מתחייבת לפעילות רציפה ונטולת תקלות.
          </p>
          <p>
            4.4 הגבלת אחריות - הנהלת האתר אינה אחראית לכל נזק, ישיר או עקיף,
            שעלול להיגרם כתוצאה משימוש באתר או בקהילות.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. פרטיות ואבטחת מידע</h2>
        <div className="space-y-2">
          <p>
            5.1 איסוף מידע - האתר עשוי לאסוף מידע אנונימי או מידע אישי שהוזן בעת
            שימוש באתר.
          </p>
          <p>
            5.2 שימוש בעוגיות (Cookies) - האתר משתמש בקבצי עוגיות לשיפור חוויית
            המשתמש.
          </p>
          <p>
            5.3 שימוש במידע אישי - לא יועבר מידע אישי לצד שלישי ללא אישור
            המשתמש, למעט מקרים המתחייבים על פי חוק.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. פרסום ומסחור</h2>
        <div className="space-y-4">
          <div>
            <p>6.1 מודעות ופרסומים ממומנים -</p>
            <p className="mt-2">
              האתר עשוי לכלול פרסומות, קישורים ממומנים או תוכן פרסומי של צדדים
              שלישיים, לרבות חברות תיירות, ביטוחים, ציוד טיולים, שירותי טיסות,
              הזמנת לינה ועוד. פרסומים מסוג זה עשויים להניב הכנסות להנהלת האתר
              (לרבות דרך תכניות אפיליאציה - Affiliate Marketing).
            </p>
          </div>

          <div>
            <p>6.2 תוכן שיווקי סמוי -</p>
            <p className="mt-2">
              האתר עשוי לפרסם תוכן בעל אופי שיווקי או מסחרי. ייעשה מאמץ לסמן
              תוכן כזה באופן ברור ככל שניתן.
            </p>
          </div>

          <div>
            <p>6.3 רכישות דרך קישורי אפיליאייט -</p>
            <p className="mt-2">
              במקרים מסוימים, חלק מהקישורים באתר מפנים לאתרים חיצוניים כחלק
              משיתופי פעולה שיווקיים (Affiliate). רכישה של מוצר או שירות דרך
              קישורים אלו מתבצעת מול החברה החיצונית בלבד, ועל אחריותה הבלעדית.
              <br />
              הנהלת האתר אינה צד לעסקה, אינה אחראית למוצר או לשירות שיסופק
              בפועל, ואינה אחראית לכל נזק, עוגמת נפש או טענה שתעלה כתוצאה
              מהרכישה.
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">
          7. שינויים בתקנון ובמדיניות האתר
        </h2>
        <div className="space-y-2">
          <p>
            7.1 עדכוני התקנון - הנהלת האתר רשאית לשנות את התקנון מעת לעת,
            והשינויים ייכנסו לתוקף מיד עם פרסומם באתר.
          </p>
          <p>
            7.2 אחריות המשתמש להתעדכן - באחריות המשתמש לבדוק את התקנון ולפעול על
            פיו.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">
          8. הפרת התקנון והשלכותיה
        </h2>
        <div className="space-y-4">
          <p>
            8.1 הרחקה והגבלת משתמשים - משתמש שיפר את התקנון עשוי להיות מורחק
            מהקהילה או מהאתר.
          </p>
          <p>
            8.2 הסרת תוכן מפר - הנהלת האתר רשאית להסיר כל תוכן המפר את התקנון,
            ללא הודעה מוקדמת.
          </p>
          <p>
            8.3 צעדים משפטיים - במקרים חמורים, הנהלת האתר רשאית לנקוט בצעדים
            משפטיים כנגד משתמשים שעברו על החוק.
          </p>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">9. יצירת קשר</h2>
        <p>
          לכל שאלה, הערה או פנייה בנושא תקנון זה ניתן לפנות למנהלי האתר בדוא"ל:
        </p>
        <p className="mt-2">📩 no.limits.east@gmail.com</p>
      </div>
    </div>
  );
};

export default Terms;
